import Navbar from "../components/Navbar";
import Contact from "../components/Contact";
import { Footer, WhatsAppFloat } from "../components/Footer";

export default function ContactPage() {
  return (
    <>
      <Navbar />
      <Contact />
      <Footer />
      <WhatsAppFloat />
    </>
  );
}